import '../../assets/css/DubaiPackage.css'
import React from "react";
import { motion } from "framer-motion";

const images = [
  "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
  "https://images.unsplash.com/photo-1489515217757-5fd1be406fef",
  "https://images.unsplash.com/photo-1526498460520-4c246339dccb",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
  "https://images.unsplash.com/photo-1500375592092-40eb2168fd21",
  "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e",
];

export default function DubaiPackage() {
  return (
    <section className="dubaiWrap">

      {/* NEW FLOATING ANIMATION SHAPES */}
      <div className="floatingCircle one"></div>
      <div className="floatingCircle two"></div>

      {/* glow background */}
      <div className="dubaiGlow glow1"></div>
      <div className="dubaiGlow glow2"></div>

      <motion.div
        className="dubaiCard"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        whileHover={{ scale: 1.02 }}
      >

        {/* IMAGE GRID */}
        <div className="dubaiGrid">
          {images.map((img, i) => (
            <motion.div
              key={i}
              className="dubaiImgBox"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.08 }}
              whileHover={{ scale: 1.08, rotate: 1 }}
            >
              <img src={img} alt="Dubai" />
            </motion.div>
          ))}
        </div>

        {/* CONTENT */}
        <motion.div
          className="dubaiContent"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
        >

          <h2>Dubai Luxury Package</h2>

          <p className="duration">
            Duration: 5 Days / 4 Nights
          </p>

          <div className="includes">
            <h4>Includes:</h4>
            <ul>
              <li>Hotel Stay</li>
              <li>Desert Safari</li>
              <li>City Tour</li>
              <li>Visa Assistance</li>
            </ul>
          </div>

          <p className="note">
            Luxury experience at best price
          </p>

          {/* 🔥 BUTTON */}
          <motion.a
            href="tel:+91 9699581519"
            className="callBtnDubai"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
          >
            📞 Call to Get Offers
          </motion.a>

        </motion.div>

      </motion.div>

    </section>
  );
}